/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 */
 document.addEventListener('variant:changed', function (event) {
    var variant = event.detail.variant; // Gives you access to the whole variant details

    // udpate price  - apparently the theme formatting functions are not avilable here so we have to do our own, US only
    var newPrice = new Intl.NumberFormat('en-us').format((variant.price * 0.01).toFixed(2));
    // update in sticky header
    var productStickyPrice = document.querySelector('.ProductStickyBar__Price.Price');
    productStickyPrice.textContent = '$' + newPrice;

    // update in product description
    var productDescriptionPrice = document.querySelector('.ProductForm__Price');
    productDescriptionPrice.innerHTML = '$' + newPrice;

    // These are added by theme, so we have to hack the CSS to make it like it doesn't happen
    // hiding price in the ProductMeta__PriceList Heading area through CSS since we don't ever want to display it
    // hiding price in ProductForm__AddToCart through CSS since we don't ever want to display it

});
/*
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

/* User account form helpers - primarily to deal with floating labels and avoiding
 *  placeholder text that creates repetition for screen readers 
 */

// this depends on input element being immediately before label element
document.addEventListener("DOMContentLoaded", function () {
    // user form label listeners to move label when field not empty
    document.querySelectorAll('.Form__FloatingLabel').forEach(function (item) {
        // check for value on load
        let field = item.previousElementSibling;
        if (field.value !== '') {
            item.classList.add('floatLabel');
        } else {
            item.classList.remove('floatLabel');
        }

        // check for value when changed
        field.addEventListener('input', function (e) {
            let label = e.target.nextElementSibling;
            if (this.value !== '') {
                label.classList.add('floatLabel');
            } else {
                label.classList.remove('floatLabel');
            }
        });
    });
});

/* end user account form helpers */

/* script for masterbuilt.app to direct to mobile app */
function getHostName() {
    var hostname = window.location.hostname;
    if (hostname.includes("masterbuilt.app") && window.location.pathname != "/pages/app-download") {
        return true;
    } else {
        return false;
    }
}

function getMobileOperatingSystem() {
    if (getHostName()) {
        //alert(getHostName());

        var userAgent = navigator.userAgent || navigator.vendor || window.opera;

        // Windows Phone must come first because its UA also contains "Android"
        if (/windows phone/i.test(userAgent)) {
            return "Windows Phone";
        }

        if (/android/i.test(userAgent)) {
            return "Android";
        }

        // iOS detection from: http://stackoverflow.com/a/9039885/177710
        if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            return "iOS";
        }

        return userAgent;
    }

}

function DetectAndServe() {
    if (getHostName()) {
        let os = getMobileOperatingSystem();
        //alert(os);

        if (os == "Android") {
            window.location.href = "https://play.google.com/store/apps/details?id=com.masterbuilt.masterbuilt&hl=en_US&gl=US";
        } else if (os == "iOS") {
            window.location.href = "https://apps.apple.com/us/app/masterbuilt/id895935056";
        } else if (os == "Windows Phone") {
            window.location.href = "https://masterbuilt.app/pages/app-download";
        } else {
            window.location.href = "https://masterbuilt.app/pages/app-download";
        }
    }
}
DetectAndServe();
/* end mobile redirection script */
